import { render, staticRenderFns } from "./myPromotion.vue?vue&type=template&id=5c803b0a&scoped=true&"
import script from "./myPromotion.vue?vue&type=script&lang=js&"
export * from "./myPromotion.vue?vue&type=script&lang=js&"
import style0 from "./myPromotion.vue?vue&type=style&index=0&id=5c803b0a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./myPromotion.vue?vue&type=style&index=1&id=5c803b0a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c803b0a",
  null
  
)

export default component.exports